import React from 'react';
import { List, Datagrid, TextField, EmailField } from 'react-admin';

const offerActionList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
        </Datagrid>
    </List>
);

export default offerActionList;